"use client";

import { useCallback } from "react";
import { useTranslations } from "next-intl";
import { AMOUNT_PLACEHOLDER, toAmount } from "./amount";

/**
 * Formats a repayment period given in months as a localized duration. Replaces
 * the hardcoded Swedish "år"/"månader" strings, which leaked into the Finnish
 * flow.
 */
export const useMonthsToYears = () => {
	const t = useTranslations("common.duration");

	return useCallback(
		(months: number | null | undefined): string => {
			const total = toAmount(months);

			if (total === null) {
				return AMOUNT_PLACEHOLDER;
			}

			const years = Math.floor(total / 12);
			const remainderMonths = total % 12;

			if (years === 0) {
				return t("months", { months: remainderMonths });
			}

			if (remainderMonths === 0) {
				return t("years", { years });
			}

			return t("yearsAndMonths", {
				years: t("years", { years }),
				months: t("months", { months: remainderMonths }),
			});
		},
		[t]
	);
};
